import { MobileResourceNavItem } from 'models/Navigation'
import { useEffect, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getUnreadMessageCount, setSelectedMessageId } from 'redux/reducers/messages'
import { getUserLoggedInState } from 'redux/reducers/users'
import events, { Event } from 'pubsub/events'
import { setOpenModal } from 'redux/reducers/header'
import i18n from 'i18n/config'
import { SubNav } from '../SubNav/SubNav'
import { Categories } from 'constants/analytics'
import { MobileNavOption } from '../MobileNavOption/MobileNavOption'

interface MobileNavSubListProps {
  navList: MobileResourceNavItem[];
  onNavOptionClick: ((input: any) => (void));
  bottomBorder: boolean;
  handleCloseButtonClick: () => void;
  currentOpenModal: string;
  enableMessageCenter: boolean;
}

export const MobileNavSubList: React.FC<MobileNavSubListProps> = ({ handleCloseButtonClick, navList, onNavOptionClick, bottomBorder, currentOpenModal, enableMessageCenter }) => {
  const ulClasses = `ch-c-mobile-nav__options-list${bottomBorder ? ' ch-c-mobile-nav__options-list-separator' : ''}`
  const dispatch = useDispatch()
  const unreadMessageCount = useSelector(getUnreadMessageCount)
  const isLoggedIn = useSelector(getUserLoggedInState)
  const subNavDict = useMemo(() => { return {} }, []) as any

  useEffect(() => {
    onNavOptionClick(subNavDict[currentOpenModal])
  }, [currentOpenModal, onNavOptionClick, subNavDict, handleCloseButtonClick])

  return (
    <ul className={ulClasses}>
      {
        navList.map(navOption => {
          const handleBackClick = () => {
            onNavOptionClick(undefined)

            dispatch(setOpenModal('mobileMenu'))

            const options: Event = {
              authenticated: isLoggedIn,
              text: 'Back',
              targetLocation: 'Back to main mobile navigation',
              heading: navOption.label,
              category: Categories.MobileNav,
              activity: 'Link Click',
              url: window.location.href,
              language: i18n.language,
              title: document.title,
              sendToTealium: true,
              sendToCoreAPI: true,
              isMessageCenter: false
            }

            events.publish(options)
          }

          const subNav = (
            <SubNav
              analyticsCategory={navOption.analyticsCategory}
              menu={navOption.menu}
              menuName={navOption.label}
              sections={navOption.subsections}
              onBack={handleBackClick}
            />
          )
          subNavDict['mobile' + navOption.label] = subNav

          const handleNavOptionClick = () => {
            onNavOptionClick(subNav)

            dispatch(setOpenModal(`mobile${navOption.label}`))

            const options: Event = {
              authenticated: isLoggedIn,
              text: navOption.gaText || navOption.label,
              category: navOption.analyticsCategory,
              targetLocation: navOption.href,
              activity: 'Link Click',
              url: window.location.href,
              language: i18n.language,
              title: document.title,
              sendToTealium: true,
              sendToCoreAPI: true,
              isMessageCenter: false
            }

            events.publish(options)
          }

          const navOptionPartialProps = {
            labelHasPotentialPii: navOption.labelHasPotentialPii,
            label: navOption.label,
            icon: navOption.icon,
            noCaret: !navOption.subsections && !navOption.menu
          }

          if (navOption.isMessageCenter && enableMessageCenter) {
            return (
              <li key={navOption.id + navOption.label}>
                <MobileNavOption
                  {...navOptionPartialProps}
                  onClick={() => {
                    dispatch(setSelectedMessageId(''))
                    handleCloseButtonClick()
                  }}
                  unreadMessageCount={unreadMessageCount}
                />
              </li>
            )
          } else {
            return (
              <li key={navOption.id + navOption.label}>
                <MobileNavOption
                  {...navOptionPartialProps}
                  onClick={handleNavOptionClick}
                  href={navOption.href}
                />
              </li>
            )
          }
        })
      }
    </ul>
  )
}
